import { render, staticRenderFns } from "./fetch.vue?vue&type=template&id=0bd70118"
import script from "./fetch.vue?vue&type=script&lang=js"
export * from "./fetch.vue?vue&type=script&lang=js"
import style0 from "./fetch.vue?vue&type=style&index=0&id=0bd70118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports